module.exports = "<div>\n    <label class=\"custom-control custom-checkbox pl-4\">\n        <input type=\"checkbox\" class=\"custom-control-input\" [ngModel]=\"categoryTotal.checked\" (ngModelChange)=\"onChange($event)\" />\n        <span class=\"custom-control-indicator\"></span>\n        <span class=\"custom-control-description pl-2\"><h5>{{ categoryTotal.name }} ({{ categoryTotal.count }})</h5></span>\n    </label>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/threshold/components/search/search-category-checkbox.component.html
// module id = ./src/app/threshold/components/search/search-category-checkbox.component.html
// module chunks = 0